// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dual-spinner {
  width: 48px;
  height: 48px;
  position: relative;
}

.dual-spinner::before,
.dual-spinner::after {
  content: "";
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 5px solid transparent;
}

.dual-spinner::before {
  border-top-color: #6f8fb8;
  border-right-color: #6f8fb8;
  animation: spin-clockwise 0.9s linear infinite;
}

.dual-spinner::after {
  inset: 6px;
  border-bottom-color: #3f6ea5;
  border-left-color: #3f6ea5;
  animation: spin-counter 0.7s linear infinite;
}

@keyframes spin-clockwise {
  to {
    transform: rotate(360deg);
  }
}
@keyframes spin-counter {
  to {
    transform: rotate(-360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/spinner/spiner.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AACF;;AAEA;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,kBAAA;EACA,6BAAA;AACF;;AAEA;EACE,yBAAA;EACA,2BAAA;EACA,8CAAA;AACF;;AAEA;EACE,UAAA;EACA,4BAAA;EACA,0BAAA;EACA,4CAAA;AACF;;AAEA;EACE;IACE,yBAAA;EACF;AACF;AAEA;EACE;IACE,0BAAA;EAAF;AACF","sourcesContent":[".dual-spinner {\n  width: 48px;\n  height: 48px;\n  position: relative;\n}\n\n.dual-spinner::before,\n.dual-spinner::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  border-radius: 50%;\n  border: 5px solid transparent;\n}\n\n.dual-spinner::before {\n  border-top-color: #6f8fb8;\n  border-right-color: #6f8fb8;\n  animation: spin-clockwise 0.9s linear infinite;\n}\n\n.dual-spinner::after {\n  inset: 6px;\n  border-bottom-color: #3f6ea5;\n  border-left-color: #3f6ea5;\n  animation: spin-counter 0.7s linear infinite;\n}\n\n@keyframes spin-clockwise {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes spin-counter {\n  to {\n    transform: rotate(-360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
